export default "__VITE_ASSET__TS0jpz4S__"